import "./category.css"

export function Category({ icon, hoverIcon, title, activeCategory, toggleCategory }) {
    return (
        <div className="category d-flex flex-column cntr gap-3 p-4 rounded-1"
            onClick={() => toggleCategory(title)}
            style={{ backgroundColor: activeCategory === title ? "#db4444" : "" }}>
                <img
                    className="category-icon"
                    src={activeCategory === title ? hoverIcon : icon}
                    alt={title}
                />
                
                <div className={activeCategory === title ? "text-white" : ""}>
                    {title}
                </div>
        </div>
    )
}